import { render, staticRenderFns } from "./SupplierManufacturingAuthenticity.vue?vue&type=template&id=e70df8b4&scoped=true&"
import script from "./SupplierManufacturingAuthenticity.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingAuthenticity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70df8b4",
  null
  
)

export default component.exports